<script>
  import type { IScheduleRow, IScheduleWeek } from "./Schedule.svelte";
  import { t } from "../../../core";

  export let row: IScheduleRow;
  export let week: IScheduleWeek;
  export let currentWeekIndex: number;
  export let deadlineWeekIndex: number | null;
</script>

<div
  class="data-cell"
  class:active={currentWeekIndex === week.index}
  class:past={currentWeekIndex > week.index}
>
  {#if row.expectedWeekIndexes.includes(week.index)}
    <span class="data-cell-line expected" />
  {/if}
  {#if row.realWeekIndexes.includes(week.index)}
    <span class="data-cell-line real" />
  {/if}
  {#if row.delayWeekIndexes.includes(week.index)}
    <span class="data-cell-line delay" />

    {#if row.comment && row.delayWeekIndexes.indexOf(week.index) === 0}
      <span class="data-cell-comment">
        {row.comment}
      </span>
    {/if}
  {/if}
  {#if deadlineWeekIndex === week.index}
    <span
      class="deadline"
      data-tooltip={t("SchedulePanel.Info.DeadlineTooltip")}
    />
  {/if}
</div>

<style lang="scss">
  .data-cell {
    position: relative;

    width: 40px;
    min-width: 40px;
    border-left: 1px solid #dedede;
    border-bottom: 1px solid #a2a2a2;

    &.active {
      box-shadow: inset 3px 0 0 0 #db8700;
      border-left-color: #db8700;
    }
    &.past {
      background: #ebebeb;
    }
  }
  .deadline {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    width: 4px;
    height: 100%;
    @include stripes-deadline-pattern;
  }
  .data-cell-line {
    position: absolute;
    z-index: 2;
    display: inline-block;
    width: 40px;
    margin-left: -1px;
    height: 8px;
  }
  .expected {
    background-color: #a7a7a7;
    top: calc(50% - 8px);
  }
  .delay {
    top: calc(50%);
    background-color: #942810;
  }
  .real {
    top: calc(50%);
    background-color: #002c64;
  }

  .data-cell-comment {
    position: absolute;
    z-index: 2;
    left: 0;
    top: calc(50% + 10px);
    white-space: nowrap;

    @include small;
    color: $warning-color;

    .active & {
      left: 6px;
    }
  }
</style>
